module.exports = __webpack_public_path__ + "media/images/pc/stores/shinjuku/shinjuku_concept_01-59079deafbcab966c8a3f39d31e9561b.jpg";